<template>
	<span class="error-feedback">
		<i class="icon icon-warning"></i>
		<ul class="error-feedback__items">
			<li
				class="error-feedback__item"
				v-for="message in errorMessages"
				:key="message"
			>
				{{ message }}
			</li>
		</ul>
	</span>
</template>

<script>
export default {
	name: 'ErrorFeedback',
	props: {
		errorMessages: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
// UI/UX Note: review and tweek for a case with multiples messages

.error-feedback {
	display: flex;
	font-size: $field-error-font-size;
	margin-top: $gutter-sm;
	padding: $padding-xs;
	background-color: var(--ui-negative-light);
	border-radius: $border-radius;
	border: 1px solid var(--ui-negative);
	width: fit-content;

	& .icon {
		color: var(--ui-negative);
		font-size: $field-icon-error-help-font-size;
	}

	&__items {
		display: inline-flex;
		flex-direction: column;
		min-width: calc(
			100% - (14px + #{$gutter-sm})
		); //icon container width + the right margin
		color: $ui-fg-dark;
	}

	&__item {
		display: inline-block;
		vertical-align: middle;
		width: 100%;
	}

	> *:first-child {
		margin-right: $gutter-sm;
	}
}
</style>
